import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class ParameterManagementTypeService {

    constructor() { }

    private ToolType = new Subject<any>();
    data: any;

    // Observable string streams
    ToolType$ = this.ToolType.asObservable();

    get() {
        return this.ToolType.next(this.data);
    }

    add(obj: string) {
        this.data = obj;
        this.ToolType.next(obj);
    }
}
